import { Component, ChangeDetectorRef } from '@angular/core';
import { DeviceSerialNumber, ExternalCamera, Organization, User } from '@pages/camera-settings/models';
import { DeviceSerialNumberService, ExternalCameraService, OrganizationService, ReportService, UserService } from '@services/organization.service';
import { ColDef } from 'ag-grid-community';
import { firstValueFrom } from 'rxjs';
import { faExpand, faFileExcel, faExpandAlt, faExpandArrowsAlt } from '@fortawesome/free-solid-svg-icons';
import { FormControl, FormGroup } from '@angular/forms';
import { faChevronUp, faChevronDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';


import { faBars, faTimes, faBackwardStep, faBackward, faForwardStep, faForward, faGreaterThan, faLessThan, faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';



export interface IFailedLoginAttempts {
  LoginDate: Date;
  Account: string;
  Organisation: string
  FailedLoginAttempt: number;
}

export interface IMFAConfiguration {
  Account: string;
  Organisation: string;
  EmailAddress: string;
  Mobile: string;
  Authentication_app_configured: boolean;
}

export interface ICheckInAttempts {
  CheckIn_Date: Date;
  Account: string;
  Organisation: string;
  CheckIn_Attempt: number;
}

export interface ICheckOutAttempts {
  CheckOut_Date: Date;
  Account: string;
  Organisation: string;
  CheckOut_Attempt: number;
}
export interface ISessionsCaptured {
  SessionDate: Date;
  Account: string;
  Organisation: string;
  Sessions: number;
}
export interface ITriggeredSenseDeviceHistory {
  TriggerDeviceLogDate: Date;
  SerialNumber: string;
  Organisation: string;
  Assignee: string;
  TriggeredByUser: string;
  TriggeredByEvent: string;
}

type ReportType = 'failedLoginAttempts' | 'mfaConfiguration' | 'userCheckInAttempts' | 'userCheckoutAttempts' | 'sessionCapture' | 'deviceHistory';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent {
  themeClass = "ag-theme-quartz";
  isExpanded: boolean = true;
  isExportable: boolean = false;
  securitySubMenu: boolean = true;
  userAccountSubMenu: boolean = false;
  devicesSubMenu: boolean = false;
  faFileExcel = faFileExcel;
  faExpand = faExpand;
  faExpandAlt = faExpandAlt;
  faExpandArrowAlt = faExpandArrowsAlt;
  faChevronUp = faChevronUp
  faChevronDown = faChevronDown;
  faBars = faBars;
  faTimes = faTimes;
  faForward = faForward;
  faBackward = faBackward;
  faForwardStep = faForwardStep;
  faBackwardStep = faBackwardStep;
  faGreaterThan = faGreaterThan;
  faLessThan = faLessThan;
  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;

  selectedReport: ReportType = 'failedLoginAttempts';

  rowData: any[] = [];
  colDefs: any[] = [];
  gridApi: any;
  gridColumnApi: any;
  organizations: Organization[];
  selectedOrganizationId: number = -1;
  users: User[];
  selectedUserId: number = -1;
  externalCameras: ExternalCamera[];
  selectedCamera: number;
  deviceSerialNumbers: DeviceSerialNumber[];
  selectedSerialNumber: number;
  quickFilterText: string = "";

  range = new FormGroup({
    start: new FormControl<Date | null>(new Date()),
    end: new FormControl<Date | null>(new Date()),
  });

  icons: {
    menu: '<i class="fa fa-bars" />',
    filter: '<i class="fa fa-long-arrow-alt-up"/>',
    columns: '<i class="fa fa-snowflake"/>',
    sortAscending: '<i class="fa fa-sort-alpha-up"/>',
    sortDescending: '<i class="fa fa-sort-alpha-down"/>',
  }

  toggleLoginSubmenu(e: any) {
    e.preventDefault();
    this.securitySubMenu = !this.securitySubMenu;
  }

  toggleCheckinSubmenu(e: any) {
    e.preventDefault();
    this.userAccountSubMenu = !this.userAccountSubMenu;
  }

  toggleDevicesSubmenu(e: any) {
    e.preventDefault();
    this.devicesSubMenu = !this.devicesSubMenu;
  }


  constructor(
    public organizationsService: OrganizationService,
    public userService: UserService,
    public cameraService: ExternalCameraService,
    public reportService: ReportService,
    public deviceSerialNumberService: DeviceSerialNumberService,
    private changeDetector: ChangeDetectorRef) {
    let currentDate = new Date();
    let startOfYear = new Date(currentDate.getFullYear(), 0, 1);

    this.range = new FormGroup({
      start: new FormControl<Date | null>(startOfYear),
      end: new FormControl<Date | null>(currentDate),
    });

    this.ReportSelection();
  }

  async ngOnInit() {
    await this.FetchOrganizations();
    await this.FetchUsers();
    await this.FetchExternalCameras();
    await this.FetchDeviceSerialNumber();
  }

  onBtnExport() {
    let params = {
      fileName: this.reportName(this.selectedReport)

    };
    this.gridApi.exportDataAsCsv(params);
  }

  private async FetchOrganizations() {
    const organizations: Organization[] = await firstValueFrom(
      this.organizationsService.getOrganizations()
    );
    organizations.sort((a, b) => a.CompanyId - b.CompanyId);
    this.organizations = [{ CompanyId: -1, Name: "All" }, ...organizations];
    this.selectedOrganizationId = this.organizations[0].CompanyId;
  }

  private async FetchUsers() {
    const users: User[] = await firstValueFrom(
      this.userService.getUsers(this.selectedOrganizationId)
    );
    users.sort((a, b) => a.UserId - b.UserId);
    this.users = [{ UserId: -1, UserName: "All" }, ...users];
    this.selectedUserId = this.users[0].UserId;
  }

  private async FetchExternalCameras() {
    const cameras: ExternalCamera[] = await firstValueFrom(
      this.cameraService.getExternalCameras()
    );
    cameras.sort((a, b) => a.Key - b.Key);
    this.externalCameras = [{ Key: -1, Value: "All" }, ...cameras];
    this.selectedCamera = this.externalCameras[0].Key;
  }

  onDateFromChange($event: any) {
    this.ReportSelection();
  }

  onDateToChange($event: any) {
    this.ReportSelection();
  }

  reportName(selectedReport: ReportType) {
    switch (selectedReport) {
      case 'deviceHistory':
        return 'Device History'
      case 'failedLoginAttempts':
        return 'Failed Login Attempts';
      case 'mfaConfiguration':
        return 'MFA Configuration';
      case 'sessionCapture':
        return 'SessionCapture';
      case 'userCheckInAttempts':
        return 'User CheckIn Attempts';
      case 'userCheckoutAttempts':
        return 'User Checkout Attempts';

    }
  }

  private async FetchDeviceSerialNumber() {
    const srNo: DeviceSerialNumber[] = await firstValueFrom(
      this.deviceSerialNumberService.getSerialNumbers()
    );
    srNo.sort((a, b) => a.Key - b.Key);
    console.log(srNo);
    this.deviceSerialNumbers = [{ Key: -1, Value: "All" }, ...srNo];
    this.selectedSerialNumber = this.deviceSerialNumbers[0].Key;
  }

  onDeviceSerialNumberChange($event: any) {
    this.selectedSerialNumber = $event.value;
    this.ReportSelection();
  }

  onExternalCameraChange($event: any) {
    this.selectedCamera = $event.value;
    this.ReportSelection();
  }

  onPageChange(newPage: number): void {
    this.gridApi.paginationGoToPage(newPage);
  }
  getCurrentPage(): number {
    return this.gridApi ? this.gridApi.paginationGetCurrentPage() : 0;
  }
  getTotalPages(): number {
    return this.gridApi ? this.gridApi.paginationGetTotalPages() : 1;
  }
  onPageSizeChange(newPageSize: number): void {
    this.gridApi.paginationSetPageSize(Number(newPageSize));
  }

  onOrganizationChange($event: any) {
    console.log("called");
    this.selectedOrganizationId = $event.value;
    this.FetchUsers();
    this.ReportSelection();
  }

  onUserChange($event: any) {
    this.selectedUserId = $event.value;
    this.ReportSelection();
  }

  ngOnChanges() {
    this.ReportSelection();
  }
  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }
  
  onChangeReport($event: any, reportType: ReportType) {
    $event.preventDefault();
    this.quickFilterText = "";
    this.gridApi.setGridOption('quickFilterText', this.quickFilterText);
    this.selectedReport = reportType;
    this.ReportSelection();
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
    window.addEventListener('resize', () => {
      this.gridApi.sizeColumnsToFit();
    });
  }

  getDateValues() {
    let dateFrom = this.range.get("start").value;
    let dateTo = this.range.get("end").value;
    let dateFromString: string = null;
    let dateToString: string = null;

    console.log("DateFrom : ", dateFrom);
    console.log("DateTo : ", dateTo);

    if (dateFrom) {
      dateFromString = dateFrom.toISOString().split('T')[0];
    }

    if (dateTo) {
      dateToString = dateTo.toISOString().split('T')[0];
    }
    return { dateFrom: dateFromString, dateTo: dateToString };
  }

  onFilterTextBoxChanged($event: any) {
    this.quickFilterText = $event.target.value;
    console.log("onFilterTextBoxChanged quickFilterText : ", this.quickFilterText);
    this.gridApi.setGridOption('quickFilterText', this.quickFilterText);
    this.IsReportExportable();
  }

  IsReportExportable(){
    if(this.gridApi.getModel().rowsToDisplay.length > 0){
      this.isExportable = true
    }
    else{
      this.isExportable = false
    }
  }

  ReportSelection() {
    switch (this.selectedReport) {
      case "failedLoginAttempts":
        this.failedLoginAttemptReport();
        break;
      case "userCheckInAttempts":
        this.userCheckinReport();
        break;
      case "userCheckoutAttempts":
        this.userCheckoutReport();
        break;
      case "sessionCapture":
        this.sessionCaptureReport();
        break;
      case "mfaConfiguration":
        this.mfaConfigurationReport();
        break;
      case "deviceHistory":
        this.deviceHistoryReport();
        break;
    }
    this.gridApi?.sizeColumnsToFit();
  }

  async failedLoginAttemptReport() {
    let { dateFrom, dateTo } = this.getDateValues();
    let filter = {
      userId: this.selectedUserId || 0,
      companyId: this.selectedOrganizationId || 0,
      dateFrom: dateFrom,
      dateTo: dateTo
    }
    let data: IFailedLoginAttempts[] = await firstValueFrom(this.reportService.getFailedLoginAttemptsReport(filter));
    this.isExportable = data.length > 0;
    let failedLoginAttemptColDefs: ColDef<IFailedLoginAttempts>[] =
      [
        {
          headerName: "Company",
          field: 'Organisation',
          filter: 'agMultiColumnFilter',
          flex: 1,
          icons: {
            menu: '<i class="fa fa-bars" />',
            filter: '<i class="fa fa-long-arrow-alt-up"/>',
            columns: '<i class="fa fa-snowflake"/>',
            sortAscending: '<i class="fa fa-sort-alpha-down"/>',
            sortDescending: '<i class="fa fa-sort-alpha-up"/>',
          },
          comparator: customComparator
        },
        {
          field: 'Account',
          filter: 'agMultiColumnFilter',
          flex: 1,
          icons: {
            menu: '<i class="fa fa-bars" />',
            filter: '<i class="fa fa-long-arrow-alt-up"/>',
            columns: '<i class="fa fa-snowflake"/>',
            sortAscending: '<i class="fa fa-sort-alpha-down"/>',
            sortDescending: '<i class="fa fa-sort-alpha-up"/>',
          },
          comparator: customComparator
        },
        {
          headerName: "Login Date",
          field: 'LoginDate',
          valueFormatter: params => this.formatDate(params.value),
          filter: 'agMultiColumnFilter',
          flex: 1,
          icons: {
            menu: '<i class="fa fa-bars" />',
            filter: '<i class="fa fa-long-arrow-alt-up"/>',
            columns: '<i class="fa fa-snowflake"/>',
            sortAscending: '<i class="fa fa-sort-alpha-down"/>',
            sortDescending: '<i class="fa fa-sort-alpha-up"/>',
          },
          comparator: customComparator
        },

        {
          headerName: "Failed Login Attempts",
          field: 'FailedLoginAttempt',
          filter: 'agMultiColumnFilter',
          flex: 1,
          icons: {
            menu: '<i class="fa fa-bars" />',
            filter: '<i class="fa fa-long-arrow-alt-up"/>',
            columns: '<i class="fa fa-snowflake"/>',
            sortAscending: '<i class="fa fa-sort-alpha-down"/>',
            sortDescending: '<i class="fa fa-sort-alpha-up"/>',
          }
        }
      ];

    this.rowData = data;
    this.colDefs = failedLoginAttemptColDefs;
  }


  async mfaConfigurationReport() {
    let { dateFrom, dateTo } = this.getDateValues();
    let filter = {
      userId: this.selectedUserId || 0,
      companyId: this.selectedOrganizationId || 0,
      dateFrom: dateFrom,
      dateTo: dateTo
    }
    let data: IMFAConfiguration[] = await firstValueFrom(this.reportService.getMFAConfigurationReport(filter));
    this.isExportable = data.length > 0;
    let mfaConfigurationColDefs: ColDef<IMFAConfiguration>[] = [
      {
        headerName: "Company",
        field: 'Organisation', filter: 'agMultiColumnFilter', flex: 1,
        icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'Account', filter: 'agMultiColumnFilter', flex: 1,
        icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'EmailAddress', filter: 'agMultiColumnFilter', flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'Mobile', filter: 'agMultiColumnFilter', flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'Authentication_app_configured',
        cellRenderer: params => this.booleanCellRenderer(params),
        headerName: 'Auth App Configured',
        filter: 'agMultiColumnFilter',
        flex: 1,
        icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        }
      }
    ];
    this.rowData = data;
    this.colDefs = mfaConfigurationColDefs;
  }

  booleanCellRenderer(params): string {
    return params.value
      ? '<i class="fa fa-check-circle" style="color: green; font-size: 1.5em;"></i>' // icon for true
      : '<i class="fa fa-times-circle" style="color: red; font-size: 1.5em;"></i>'; // icon for false
  }
  async userCheckinReport() {
    let { dateFrom, dateTo } = this.getDateValues();
    let filter = {
      userId: this.selectedUserId || 0,
      companyId: this.selectedOrganizationId || 0,
      dateFrom: dateFrom,
      dateTo: dateTo
    }
    let data: ICheckInAttempts[] = await firstValueFrom(this.reportService.getUserCheckinReport(filter));
    this.isExportable = data.length > 0;
    let checkInAttemptsColDefs: ColDef<ICheckInAttempts>[] = [
      {
        headerName: "Company",
        field: 'Organisation', filter: 'agMultiColumnFilter', flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'Account', filter: 'agMultiColumnFilter', flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'CheckIn_Date', headerName: 'CheckIn Date',
        valueFormatter: params => this.formatDate(params.value),
        flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'CheckIn_Attempt', headerName: 'CheckIn Attempts', filter: 'agMultiColumnFilter', flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      }
    ];
    this.rowData = data;
    this.colDefs = checkInAttemptsColDefs;
  }


  async userCheckoutReport() {
    let { dateFrom, dateTo } = this.getDateValues();
    let filter = {
      userId: this.selectedUserId || 0,
      companyId: this.selectedOrganizationId || 0,
      dateFrom: dateFrom,
      dateTo: dateTo
    }
    let data: ICheckOutAttempts[] = await firstValueFrom(this.reportService.getUserCheckoutReport(filter));
    this.isExportable = data.length > 0;
    let checkOutAttemptsColDefs: ColDef<ICheckOutAttempts>[] = [
      {
        headerName: "Company",
        field: 'Organisation', filter: 'agMultiColumnFilter', flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'Account', filter: 'agMultiColumnFilter', flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'CheckOut_Date',headerName: 'CheckOut Date', valueFormatter: params => this.formatDate(params.value), flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'CheckOut_Attempt', headerName: 'CheckOut Attempts', filter: 'agMultiColumnFilter', flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      }
    ];
    this.rowData = data;
    this.colDefs = checkOutAttemptsColDefs;
  }

  async sessionCaptureReport() {
    let { dateFrom, dateTo } = this.getDateValues();
    let filter = {
      userId: this.selectedUserId || 0,
      companyId: this.selectedOrganizationId || 0,
      deviceId: this.selectedCamera || 0,
      dateFrom: dateFrom,
      dateTo: dateTo
    }
    let data: ISessionsCaptured[] = await firstValueFrom(this.reportService.sessionCapturedReport(filter));
    this.isExportable = data.length > 0;
    let sessionsCapturedColDefs: ColDef<ISessionsCaptured>[] = [
      {
        headerName: "Company",
        field: 'Organisation', filter: 'agMultiColumnFilter', flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'Account', filter: 'agMultiColumnFilter', flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'SessionDate', valueFormatter: params => this.formatDate(params.value), flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'Sessions', filter: 'agMultiColumnFilter', flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      }
    ];
    this.rowData = data;
    this.colDefs = sessionsCapturedColDefs;
  }

  async deviceHistoryReport() {
    let { dateFrom, dateTo } = this.getDateValues();
    let filter = {
      companyId: this.selectedOrganizationId || 0,
      serialNumber: this.selectedSerialNumber || 0,
      dateFrom: dateFrom,
      dateTo: dateTo
    }
    let data: ITriggeredSenseDeviceHistory[] = await firstValueFrom(this.reportService.getDeviceSerialNumberReport(filter));
    this.isExportable = data.length > 0;
    let senseDeviceHistoryColDefs: ColDef<ITriggeredSenseDeviceHistory>[] = [
      {
        headerName: "Company",
        field: 'Organisation', filter: 'agMultiColumnFilter', flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'Assignee', filter: 'agMultiColumnFilter', flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'TriggerDeviceLogDate', valueFormatter: params => this.formatDate(params.value), flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'SerialNumber', filter: 'agMultiColumnFilter', flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'TriggeredByUser', filter: 'agMultiColumnFilter', flex: 1, icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      },
      {
        field: 'TriggeredByEvent', filter: 'agMultiColumnFilter', flex: 1, 
        icons: {
          menu: '<i class="fa fa-bars" />',
          filter: '<i class="fa fa-long-arrow-alt-up"/>',
          columns: '<i class="fa fa-snowflake"/>',
          sortAscending: '<i class="fa fa-sort-alpha-down"/>',
          sortDescending: '<i class="fa fa-sort-alpha-up"/>',
        },
        comparator: customComparator
      }
    ];
    this.rowData = data;
    this.colDefs = senseDeviceHistoryColDefs;
  }

  formatDate(value: any) {
    if (value) {
      const date = new Date(value);
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return '';
  }
}

const customComparator = (valueA, valueB) => {
  let a = String(valueA).toLowerCase();
  let b = String(valueB).toLowerCase();
  return a?.localeCompare(b);
}
